module.exports = __webpack_public_path__ + "static/media/sanjose10.52723197.jpg";